import { handleErrors } from "../util/api-utils";

export function standardizeAddress(request, successCallback = (response) => response) {
    return fetch("api/SpectrumAddress/StandardizeAddress", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};
